import {ParticleController} from "./ParticleController";
import {OldEmitterConfig} from "pixi-particles";
import {gsap} from "gsap";

export class ParticlesManager {
    private _allParticleControllers: ParticleController[] = [];

    constructor() {
        gsap.ticker.add(() => this.updateAll());
    }

    public createAnimation(layer: PIXI.Container, nameUpdate: string, texturePath: string, conf: OldEmitterConfig, loops: boolean): ParticleController {
        const PC: ParticleController = new ParticleController(layer, nameUpdate + "Particle", texturePath, conf, loops);
        this._allParticleControllers.push(PC);
        return PC;
    }

    private updateAll(): void {
        this._allParticleControllers = this._allParticleControllers.filter((pc: ParticleController) => pc.inGame);
        this._allParticleControllers.forEach((pc: ParticleController) => pc.update());
    }
}